var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vaw-nav-bar-wrapper"},[_c('Humburger'),(_vm.state.device !== 'mobile')?_c('Breadcrumb'):_vm._e(),_c('div',{staticStyle:{"flex":"1"}}),_c('div',{staticClass:"avatar-wrapper"},[_c('VAWAvatar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }